/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { util, tidy, deprecationWarn, Tensor, stack, tensor, ENV, clone, dispose, tensor_util, tensor1d, tensor2d, browser, image } from "@tensorflow/tfjs-core";

var _extendStatics = function extendStatics(t, e) {
  return (_extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (t, e) {
    t.__proto__ = e;
  } || function (t, e) {
    for (var r in e) {
      e.hasOwnProperty(r) && (t[r] = e[r]);
    }
  })(t, e);
};

function __extends(t, e) {
  function r() {
    this.constructor = t;
  }

  _extendStatics(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
}

function __awaiter(t, e, r, n) {
  return new (r || (r = Promise))(function (i, o) {
    function a(t) {
      try {
        s(n.next(t));
      } catch (t) {
        o(t);
      }
    }

    function u(t) {
      try {
        s(n.throw(t));
      } catch (t) {
        o(t);
      }
    }

    function s(t) {
      t.done ? i(t.value) : new r(function (e) {
        e(t.value);
      }).then(a, u);
    }

    s((n = n.apply(t, e || [])).next());
  });
}

function __generator(t, e) {
  var r,
      n,
      i,
      o,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & i[0]) throw i[1];
      return i[1];
    },
    trys: [],
    ops: []
  };
  return o = {
    next: u(0),
    throw: u(1),
    return: u(2)
  }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
    return this;
  }), o;

  function u(o) {
    return function (u) {
      return function (o) {
        if (r) throw new TypeError("Generator is already executing.");

        for (; a;) {
          try {
            if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

            switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
              case 0:
              case 1:
                i = o;
                break;

              case 4:
                return a.label++, {
                  value: o[1],
                  done: !1
                };

              case 5:
                a.label++, n = o[1], o = [0];
                continue;

              case 7:
                o = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                  a = 0;
                  continue;
                }

                if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                  a.label = o[1];
                  break;
                }

                if (6 === o[0] && a.label < i[1]) {
                  a.label = i[1], i = o;
                  break;
                }

                if (i && a.label < i[2]) {
                  a.label = i[2], a.ops.push(o);
                  break;
                }

                i[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            o = e.call(t, a);
          } catch (t) {
            o = [6, t], n = 0;
          } finally {
            r = i = 0;
          }
        }

        if (5 & o[0]) throw o[1];
        return {
          value: o[0] ? o[1] : void 0,
          done: !0
        };
      }([o, u]);
    };
  }
}

var commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function unwrapExports(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}

function createCommonjsModule(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}

var alea = createCommonjsModule(function (t) {
  !function (t, e, r) {
    function n(t, e) {
      return e.c = t.c, e.s0 = t.s0, e.s1 = t.s1, e.s2 = t.s2, e;
    }

    function i(t, e) {
      var r = new function (t) {
        var e,
            r = this,
            n = (e = 4022871197, function (t) {
          t = t.toString();

          for (var r = 0; r < t.length; r++) {
            var n = .02519603282416938 * (e += t.charCodeAt(r));
            n -= e = n >>> 0, e = (n *= e) >>> 0, e += 4294967296 * (n -= e);
          }

          return 2.3283064365386963e-10 * (e >>> 0);
        });
        r.next = function () {
          var t = 2091639 * r.s0 + 2.3283064365386963e-10 * r.c;
          return r.s0 = r.s1, r.s1 = r.s2, r.s2 = t - (r.c = 0 | t);
        }, r.c = 1, r.s0 = n(" "), r.s1 = n(" "), r.s2 = n(" "), r.s0 -= n(t), r.s0 < 0 && (r.s0 += 1), r.s1 -= n(t), r.s1 < 0 && (r.s1 += 1), r.s2 -= n(t), r.s2 < 0 && (r.s2 += 1), n = null;
      }(t),
          i = e && e.state,
          o = r.next;
      return o.int32 = function () {
        return 4294967296 * r.next() | 0;
      }, o.double = function () {
        return o() + 1.1102230246251565e-16 * (2097152 * o() | 0);
      }, o.quick = o, i && ("object" == typeof i && n(i, r), o.state = function () {
        return n(r, {});
      }), o;
    }

    e && e.exports ? e.exports = i : r && r.amd ? r(function () {
      return i;
    }) : this.alea = i;
  }(0, t, !1);
}),
    xor128 = createCommonjsModule(function (t) {
  !function (t, e, r) {
    function n(t, e) {
      return e.x = t.x, e.y = t.y, e.z = t.z, e.w = t.w, e;
    }

    function i(t, e) {
      var r = new function (t) {
        var e = this,
            r = "";
        e.x = 0, e.y = 0, e.z = 0, e.w = 0, e.next = function () {
          var t = e.x ^ e.x << 11;
          return e.x = e.y, e.y = e.z, e.z = e.w, e.w ^= e.w >>> 19 ^ t ^ t >>> 8;
        }, t === (0 | t) ? e.x = t : r += t;

        for (var n = 0; n < r.length + 64; n++) {
          e.x ^= 0 | r.charCodeAt(n), e.next();
        }
      }(t),
          i = e && e.state,
          o = function o() {
        return (r.next() >>> 0) / 4294967296;
      };

      return o.double = function () {
        do {
          var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);

        return t;
      }, o.int32 = r.next, o.quick = o, i && ("object" == typeof i && n(i, r), o.state = function () {
        return n(r, {});
      }), o;
    }

    e && e.exports ? e.exports = i : r && r.amd ? r(function () {
      return i;
    }) : this.xor128 = i;
  }(0, t, !1);
}),
    xorwow = createCommonjsModule(function (t) {
  !function (t, e, r) {
    function n(t, e) {
      return e.x = t.x, e.y = t.y, e.z = t.z, e.w = t.w, e.v = t.v, e.d = t.d, e;
    }

    function i(t, e) {
      var r = new function (t) {
        var e = this,
            r = "";
        e.next = function () {
          var t = e.x ^ e.x >>> 2;
          return e.x = e.y, e.y = e.z, e.z = e.w, e.w = e.v, (e.d = e.d + 362437 | 0) + (e.v = e.v ^ e.v << 4 ^ t ^ t << 1) | 0;
        }, e.x = 0, e.y = 0, e.z = 0, e.w = 0, e.v = 0, t === (0 | t) ? e.x = t : r += t;

        for (var n = 0; n < r.length + 64; n++) {
          e.x ^= 0 | r.charCodeAt(n), n == r.length && (e.d = e.x << 10 ^ e.x >>> 4), e.next();
        }
      }(t),
          i = e && e.state,
          o = function o() {
        return (r.next() >>> 0) / 4294967296;
      };

      return o.double = function () {
        do {
          var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);

        return t;
      }, o.int32 = r.next, o.quick = o, i && ("object" == typeof i && n(i, r), o.state = function () {
        return n(r, {});
      }), o;
    }

    e && e.exports ? e.exports = i : r && r.amd ? r(function () {
      return i;
    }) : this.xorwow = i;
  }(0, t, !1);
}),
    xorshift7 = createCommonjsModule(function (t) {
  !function (t, e, r) {
    function n(t, e) {
      return e.x = t.x.slice(), e.i = t.i, e;
    }

    function i(t, e) {
      null == t && (t = +new Date());

      var r = new function (t) {
        var e = this;
        e.next = function () {
          var t,
              r,
              n = e.x,
              i = e.i;
          return t = n[i], r = (t ^= t >>> 7) ^ t << 24, r ^= (t = n[i + 1 & 7]) ^ t >>> 10, r ^= (t = n[i + 3 & 7]) ^ t >>> 3, r ^= (t = n[i + 4 & 7]) ^ t << 7, t = n[i + 7 & 7], r ^= (t ^= t << 13) ^ t << 9, n[i] = r, e.i = i + 1 & 7, r;
        }, function (t, e) {
          var r,
              n = [];
          if (e === (0 | e)) n[0] = e;else for (e = "" + e, r = 0; r < e.length; ++r) {
            n[7 & r] = n[7 & r] << 15 ^ e.charCodeAt(r) + n[r + 1 & 7] << 13;
          }

          for (; n.length < 8;) {
            n.push(0);
          }

          for (r = 0; r < 8 && 0 === n[r]; ++r) {
            ;
          }

          for (8 == r ? n[7] = -1 : n[r], t.x = n, t.i = 0, r = 256; r > 0; --r) {
            t.next();
          }
        }(e, t);
      }(t),
          i = e && e.state,
          o = function o() {
        return (r.next() >>> 0) / 4294967296;
      };

      return o.double = function () {
        do {
          var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);

        return t;
      }, o.int32 = r.next, o.quick = o, i && (i.x && n(i, r), o.state = function () {
        return n(r, {});
      }), o;
    }

    e && e.exports ? e.exports = i : r && r.amd ? r(function () {
      return i;
    }) : this.xorshift7 = i;
  }(0, t, !1);
}),
    xor4096 = createCommonjsModule(function (t) {
  !function (t, e, r) {
    function n(t, e) {
      return e.i = t.i, e.w = t.w, e.X = t.X.slice(), e;
    }

    function i(t, e) {
      null == t && (t = +new Date());

      var r = new function (t) {
        var e = this;
        e.next = function () {
          var t,
              r,
              n = e.w,
              i = e.X,
              o = e.i;
          return e.w = n = n + 1640531527 | 0, r = i[o + 34 & 127], t = i[o = o + 1 & 127], r ^= r << 13, t ^= t << 17, r ^= r >>> 15, t ^= t >>> 12, r = i[o] = r ^ t, e.i = o, r + (n ^ n >>> 16) | 0;
        }, function (t, e) {
          var r,
              n,
              i,
              o,
              a,
              u = [],
              s = 128;

          for (e === (0 | e) ? (n = e, e = null) : (e += "\0", n = 0, s = Math.max(s, e.length)), i = 0, o = -32; o < s; ++o) {
            e && (n ^= e.charCodeAt((o + 32) % e.length)), 0 === o && (a = n), n ^= n << 10, n ^= n >>> 15, n ^= n << 4, n ^= n >>> 13, o >= 0 && (a = a + 1640531527 | 0, i = 0 == (r = u[127 & o] ^= n + a) ? i + 1 : 0);
          }

          for (i >= 128 && (u[127 & (e && e.length || 0)] = -1), i = 127, o = 512; o > 0; --o) {
            n = u[i + 34 & 127], r = u[i = i + 1 & 127], n ^= n << 13, r ^= r << 17, n ^= n >>> 15, r ^= r >>> 12, u[i] = n ^ r;
          }

          t.w = a, t.X = u, t.i = i;
        }(e, t);
      }(t),
          i = e && e.state,
          o = function o() {
        return (r.next() >>> 0) / 4294967296;
      };

      return o.double = function () {
        do {
          var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);

        return t;
      }, o.int32 = r.next, o.quick = o, i && (i.X && n(i, r), o.state = function () {
        return n(r, {});
      }), o;
    }

    e && e.exports ? e.exports = i : r && r.amd ? r(function () {
      return i;
    }) : this.xor4096 = i;
  }(0, t, !1);
}),
    tychei = createCommonjsModule(function (t) {
  !function (t, e, r) {
    function n(t, e) {
      return e.a = t.a, e.b = t.b, e.c = t.c, e.d = t.d, e;
    }

    function i(t, e) {
      var r = new function (t) {
        var e = this,
            r = "";
        e.next = function () {
          var t = e.b,
              r = e.c,
              n = e.d,
              i = e.a;
          return t = t << 25 ^ t >>> 7 ^ r, r = r - n | 0, n = n << 24 ^ n >>> 8 ^ i, i = i - t | 0, e.b = t = t << 20 ^ t >>> 12 ^ r, e.c = r = r - n | 0, e.d = n << 16 ^ r >>> 16 ^ i, e.a = i - t | 0;
        }, e.a = 0, e.b = 0, e.c = -1640531527, e.d = 1367130551, t === Math.floor(t) ? (e.a = t / 4294967296 | 0, e.b = 0 | t) : r += t;

        for (var n = 0; n < r.length + 20; n++) {
          e.b ^= 0 | r.charCodeAt(n), e.next();
        }
      }(t),
          i = e && e.state,
          o = function o() {
        return (r.next() >>> 0) / 4294967296;
      };

      return o.double = function () {
        do {
          var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);

        return t;
      }, o.int32 = r.next, o.quick = o, i && ("object" == typeof i && n(i, r), o.state = function () {
        return n(r, {});
      }), o;
    }

    e && e.exports ? e.exports = i : r && r.amd ? r(function () {
      return i;
    }) : this.tychei = i;
  }(0, t, !1);
}),
    seedrandom = createCommonjsModule(function (t) {
  !function (e, r) {
    var n,
        i = this,
        o = 256,
        a = 6,
        u = "random",
        s = r.pow(o, a),
        c = r.pow(2, 52),
        l = 2 * c,
        f = o - 1;

    function h(t, h, v) {
      var y = [],
          _ = d(function t(e, r) {
        var n,
            i = [],
            o = typeof e;
        if (r && "object" == o) for (n in e) {
          try {
            i.push(t(e[n], r - 1));
          } catch (t) {}
        }
        return i.length ? i : "string" == o ? e : e + "\0";
      }((h = 1 == h ? {
        entropy: !0
      } : h || {}).entropy ? [t, m(e)] : null == t ? function () {
        try {
          var t;
          return n && (t = n.randomBytes) ? t = t(o) : (t = new Uint8Array(o), (i.crypto || i.msCrypto).getRandomValues(t)), m(t);
        } catch (t) {
          var r = i.navigator,
              a = r && r.plugins;
          return [+new Date(), i, a, i.screen, m(e)];
        }
      }() : t, 3), y),
          w = new function (t) {
        var e,
            r = t.length,
            n = this,
            i = 0,
            a = n.i = n.j = 0,
            u = n.S = [];
        r || (t = [r++]);

        for (; i < o;) {
          u[i] = i++;
        }

        for (i = 0; i < o; i++) {
          u[i] = u[a = f & a + t[i % r] + (e = u[i])], u[a] = e;
        }

        (n.g = function (t) {
          for (var e, r = 0, i = n.i, a = n.j, u = n.S; t--;) {
            e = u[i = f & i + 1], r = r * o + u[f & (u[i] = u[a = f & a + e]) + (u[a] = e)];
          }

          return n.i = i, n.j = a, r;
        })(o);
      }(y),
          g = function g() {
        for (var t = w.g(a), e = s, r = 0; t < c;) {
          t = (t + r) * o, e *= o, r = w.g(1);
        }

        for (; t >= l;) {
          t /= 2, e /= 2, r >>>= 1;
        }

        return (t + r) / e;
      };

      return g.int32 = function () {
        return 0 | w.g(4);
      }, g.quick = function () {
        return w.g(4) / 4294967296;
      }, g.double = g, d(m(w.S), e), (h.pass || v || function (t, e, n, i) {
        return i && (i.S && p(i, w), t.state = function () {
          return p(w, {});
        }), n ? (r[u] = t, e) : t;
      })(g, _, "global" in h ? h.global : this == r, h.state);
    }

    function p(t, e) {
      return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e;
    }

    function d(t, e) {
      for (var r, n = t + "", i = 0; i < n.length;) {
        e[f & i] = f & (r ^= 19 * e[f & i]) + n.charCodeAt(i++);
      }

      return m(e);
    }

    function m(t) {
      return String.fromCharCode.apply(0, t);
    }

    if (r["seed" + u] = h, d(r.random(), e), t.exports) {
      t.exports = h;

      try {
        n = require("crypto");
      } catch (t) {}
    } else 0;
  }([], Math);
});
seedrandom.alea = alea, seedrandom.xor128 = xor128, seedrandom.xorwow = xorwow, seedrandom.xorshift7 = xorshift7, seedrandom.xor4096 = xor4096, seedrandom.tychei = tychei;
var seedrandom$1 = seedrandom,
    seedrandom_1 = seedrandom$1.alea;

function deepMapInternal(t, e, r, n) {
  if (void 0 === r && (r = new Map()), void 0 === n && (n = new Set()), null == t) return null;
  if (n.has(t)) throw new Error("Circular references are not supported.");
  if (r.has(t)) return r.get(t);
  var i = e(t);
  if (i.recurse && null !== i.value) throw new Error("A deep map function may not return both a value and recurse=true.");

  if (i.recurse) {
    if (isIterable(t)) {
      var o = Array.isArray(t) ? [] : {};

      for (var a in n.add(t), t) {
        var u = deepMapInternal(t[a], e, r, n);
        o[a] = u;
      }

      return n.delete(t), o;
    }

    throw new Error("Can't recurse into non-iterable type: " + t);
  }

  return r.set(t, i.value), i.value;
}

function deepZip(t, e) {
  return void 0 === e && (e = zipToList), deepZipInternal(t, e);
}

function deepZipInternal(t, e, r) {
  void 0 === r && (r = new Set());
  var n = t[0];
  if (r.has(n)) throw new Error("Circular references are not supported.");
  var i = e(t);
  if (i.recurse && null !== i.value) throw new Error("A deep zip function may not return both a value and recurse=true.");

  if (i.recurse) {
    if (isIterable(n)) {
      var o = Array.isArray(n) ? [] : {};
      r.add(n);

      var a = function a(n) {
        var i = deepZipInternal(t.map(function (t) {
          return t[n];
        }), e, r);
        o[n] = i;
      };

      for (var u in n) {
        a(u);
      }

      return r.delete(n), o;
    }

    throw new Error("Can't recurse into non-iterable type: " + n);
  }

  return i.value;
}

function zipToList(t) {
  return null === t ? null : isIterable(t[0]) ? {
    value: null,
    recurse: !0
  } : {
    value: t,
    recurse: !1
  };
}

function deepMapAndAwaitAll(t, e) {
  return __awaiter(this, void 0, void 0, function () {
    var r, n, i, o, a, u;
    return __generator(this, function (s) {
      switch (s.label) {
        case 0:
          r = new Map(), deepMapInternal(t, e, r), n = 0, i = Array.from(r.keys()), s.label = 1;

        case 1:
          return n < i.length ? (o = i[n], (a = r.get(o)) instanceof Promise ? [4, a] : [3, 3]) : [3, 4];

        case 2:
          u = s.sent(), r.set(o, u), s.label = 3;

        case 3:
          return n++, [3, 1];

        case 4:
          return [2, deepMapInternal(t, e, r)];
      }
    });
  });
}

function isIterable(t) {
  return null != t && (Array.isArray(t) || "object" == typeof t && !(t instanceof Tensor));
}

function canTensorify(t) {
  return null == t || isPrimitive(t) || Array.isArray(t) || "object" == typeof t && t instanceof Tensor || util.isTypedArray(t);
}

function isPrimitive(t) {
  return null === t || "object" != typeof t && "function" != typeof t;
}

var RingBuffer = function () {
  function t(t) {
    if (this.capacity = t, this.begin = 0, this.end = 0, null == t) throw new RangeError("Can't create a ring buffer of unknown capacity.");
    if (t < 1) throw new RangeError("Can't create ring buffer of capacity < 1.");
    this.data = new Array(t), this.doubledCapacity = 2 * t;
  }

  return t.prototype.wrap = function (t) {
    for (; t < 0;) {
      t += this.doubledCapacity;
    }

    return t % this.doubledCapacity;
  }, t.prototype.get = function (t) {
    if (t < 0) throw new RangeError("Can't get item at a negative index.");
    return this.data[t % this.capacity];
  }, t.prototype.set = function (t, e) {
    if (t < 0) throw new RangeError("Can't set item at a negative index.");
    this.data[t % this.capacity] = e;
  }, t.prototype.length = function () {
    var t = this.end - this.begin;
    return t < 0 && (t = this.doubledCapacity + t), t;
  }, t.prototype.isFull = function () {
    return this.length() === this.capacity;
  }, t.prototype.isEmpty = function () {
    return 0 === this.length();
  }, t.prototype.push = function (t) {
    if (this.isFull()) throw new RangeError("Ring buffer is full.");
    this.set(this.end, t), this.end = this.wrap(this.end + 1);
  }, t.prototype.pushAll = function (t) {
    for (var e = 0, r = t; e < r.length; e++) {
      var n = r[e];
      this.push(n);
    }
  }, t.prototype.pop = function () {
    if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");
    this.end = this.wrap(this.end - 1);
    var t = this.get(this.end);
    return this.set(this.end, void 0), t;
  }, t.prototype.unshift = function (t) {
    if (this.isFull()) throw new RangeError("Ring buffer is full.");
    this.begin = this.wrap(this.begin - 1), this.set(this.begin, t);
  }, t.prototype.shift = function () {
    if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");
    var t = this.get(this.begin);
    return this.set(this.begin, void 0), this.begin = this.wrap(this.begin + 1), t;
  }, t.prototype.shuffleExcise = function (t) {
    if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");
    var e = this.wrap(this.begin + t),
        r = this.get(e);
    return this.set(e, this.pop()), r;
  }, t;
}(),
    GrowingRingBuffer = function (t) {
  function e() {
    return t.call(this, e.INITIAL_CAPACITY) || this;
  }

  return __extends(e, t), e.prototype.isFull = function () {
    return !1;
  }, e.prototype.push = function (e) {
    t.prototype.isFull.call(this) && this.expand(), t.prototype.push.call(this, e);
  }, e.prototype.unshift = function (e) {
    t.prototype.isFull.call(this) && this.expand(), t.prototype.unshift.call(this, e);
  }, e.prototype.expand = function () {
    for (var t = 2 * this.capacity, e = new Array(t), r = this.length(), n = 0; n < r; n++) {
      e[n] = this.get(this.wrap(this.begin + n));
    }

    this.data = e, this.capacity = t, this.doubledCapacity = 2 * this.capacity, this.begin = 0, this.end = r;
  }, e.INITIAL_CAPACITY = 32, e;
}(RingBuffer);

function iteratorFromItems(t) {
  return new ArrayIterator(t);
}

function iteratorFromFunction(t) {
  return new FunctionCallIterator(t);
}

function iteratorFromConcatenated(t, e) {
  return new ChainedIterator(t, e);
}

function iteratorFromZipped(t, e) {
  return void 0 === e && (e = ZipMismatchMode.FAIL), new ZipIterator(t, e);
}

var ZipMismatchMode,
    LazyIterator = function () {
  function t() {}

  return t.prototype.toArray = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e;
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            return t = [], [4, this.next()];

          case 1:
            e = r.sent(), r.label = 2;

          case 2:
            return e.done ? [3, 4] : (t.push(e.value), [4, this.next()]);

          case 3:
            return e = r.sent(), [3, 2];

          case 4:
            return [2, t];
        }
      });
    });
  }, t.prototype.toArrayForTest = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e, r;
      return __generator(this, function (n) {
        switch (n.label) {
          case 0:
            return t = this.prefetch(100), e = [], [4, t.next()];

          case 1:
            r = n.sent(), n.label = 2;

          case 2:
            return r.done ? [3, 4] : (e.push(r.value), [4, t.next()]);

          case 3:
            return r = n.sent(), [3, 2];

          case 4:
            return [2, e];
        }
      });
    });
  }, t.prototype.resolveFully = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, this.next()];

          case 1:
            t = e.sent(), e.label = 2;

          case 2:
            return t.done ? [3, 4] : [4, this.next()];

          case 3:
            return t = e.sent(), [3, 2];

          case 4:
            return [2];
        }
      });
    });
  }, t.prototype.resolveWhile = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      var e, r;
      return __generator(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, this.next()];

          case 1:
            e = n.sent(), r = t(e.value), n.label = 2;

          case 2:
            return e.done || !r ? [3, 4] : [4, this.next()];

          case 3:
            return e = n.sent(), r = t(e.value), [3, 2];

          case 4:
            return [2];
        }
      });
    });
  }, t.prototype.handleErrors = function (t) {
    return new ErrorHandlingLazyIterator(this, t);
  }, t.prototype.filter = function (t) {
    return new FilterIterator(this, t);
  }, t.prototype.map = function (t) {
    return new MapIterator(this, t);
  }, t.prototype.mapAsync = function (t) {
    return new AsyncMapIterator(this, t);
  }, t.prototype.serialMapAsync = function (t) {
    return new AsyncMapIterator(this, t).serial();
  }, t.prototype.flatmap = function (t) {
    return new FlatmapIterator(this, t);
  }, t.prototype.forEachAsync = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2, this.map(t).resolveFully()];
      });
    });
  }, t.prototype.serialForEach = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2, this.serialMapAsync(t).resolveWhile(function (t) {
          return !0 === t;
        })];
      });
    });
  }, t.prototype.rowMajorBatch = function (t, e) {
    return void 0 === e && (e = !0), new RowMajorBatchIterator(this, t, e);
  }, t.prototype.columnMajorBatch = function (t, e, r) {
    return void 0 === e && (e = !0), void 0 === r && (r = zipToList), this.rowMajorBatch(t, e).map(function (t) {
      return deepZip(t, r);
    });
  }, t.prototype.concatenate = function (t, e) {
    return new ChainedIterator(iteratorFromItems([this, t]), e);
  }, t.prototype.take = function (t) {
    return t < 0 || null == t ? this : new TakeIterator(this, t);
  }, t.prototype.skip = function (t) {
    return t < 0 || null == t ? this : new SkipIterator(this, t);
  }, t.prototype.prefetch = function (t) {
    return new PrefetchIterator(this, t);
  }, t.prototype.shuffle = function (t, e) {
    return new ShuffleIterator(this, t, e);
  }, t.prototype.serial = function () {
    return new SerialIterator(this);
  }, t;
}(),
    ArrayIterator = function (t) {
  function e(e) {
    var r = t.call(this) || this;
    return r.items = e, r.trav = 0, r;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return "Array of " + this.items.length + " items";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e;
      return __generator(this, function (r) {
        return this.trav >= this.items.length ? [2, {
          value: null,
          done: !0
        }] : (t = this.items[this.trav], e = t instanceof Tensor ? clone(t) : t, this.trav++, [2, {
          value: e,
          done: !1
        }]);
      });
    });
  }, e;
}(LazyIterator),
    FunctionCallIterator = function (t) {
  function e(e) {
    var r = t.call(this) || this;
    return r.nextFn = e, r;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return "Function call";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        try {
          return [2, this.nextFn()];
        } catch (t) {
          throw t.message = "Error thrown while iterating through a dataset: " + t.message, t;
        }

        return [2];
      });
    });
  }, e;
}(LazyIterator),
    SerialIterator = function (t) {
  function e(e) {
    var r = t.call(this) || this;
    return r.upstream = e, r.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), r;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Serial";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, this.upstream.next()];
      });
    });
  }, e;
}(LazyIterator),
    SkipIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    return n.upstream = e, n.maxCount = r, n.count = 0, n.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Skip";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            return this.count++ < this.maxCount ? [4, this.upstream.next()] : [3, 2];

          case 1:
            return (t = e.sent()).done ? [2, t] : (dispose(t.value), [3, 0]);

          case 2:
            return [2, this.upstream.next()];
        }
      });
    });
  }, e;
}(LazyIterator),
    TakeIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    return n.upstream = e, n.maxCount = r, n.count = 0, n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Take";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return this.count++ >= this.maxCount ? [2, {
          value: null,
          done: !0
        }] : [2, this.upstream.next()];
      });
    });
  }, e;
}(LazyIterator),
    RowMajorBatchIterator = function (t) {
  function e(e, r, n) {
    void 0 === n && (n = !0);
    var i = t.call(this) || this;
    return i.upstream = e, i.batchSize = r, i.enableSmallLastBatch = n, i.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), i;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> RowMajorBatch";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e;
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            t = [], r.label = 1;

          case 1:
            return t.length < this.batchSize ? [4, this.upstream.next()] : [3, 3];

          case 2:
            return (e = r.sent()).done ? this.enableSmallLastBatch && t.length > 0 ? [2, {
              value: t,
              done: !1
            }] : [2, {
              value: null,
              done: !0
            }] : (t.push(e.value), [3, 1]);

          case 3:
            return [2, {
              value: t,
              done: !1
            }];
        }
      });
    });
  }, e;
}(LazyIterator),
    FilterIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    return n.upstream = e, n.predicate = r, n.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Filter";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, this.upstream.next()];

          case 1:
            return (t = e.sent()).done || this.predicate(t.value) ? [2, t] : (dispose(t.value), [3, 0]);

          case 2:
            return [2];
        }
      });
    });
  }, e;
}(LazyIterator),
    MapIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    return n.upstream = e, n.transform = r, n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Map";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e, r, n, i, o, a;
      return __generator(this, function (u) {
        switch (u.label) {
          case 0:
            return [4, this.upstream.next()];

          case 1:
            if ((t = u.sent()).done) return [2, {
              value: null,
              done: !0
            }];

            for (e = tensor_util.getTensorsInContainer(t.value), r = this.transform(t.value), n = tensor_util.getTensorsInContainer(r), i = 0, o = e; i < o.length; i++) {
              a = o[i], tensor_util.isTensorInList(a, n) || a.dispose();
            }

            return [2, {
              value: r,
              done: !1
            }];
        }
      });
    });
  }, e;
}(LazyIterator),
    ErrorHandlingLazyIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    return n.upstream = e, n.handler = r, n.count = 0, n.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> handleErrors";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            e.label = 1;

          case 1:
            return e.trys.push([1, 3,, 4]), [4, this.upstream.next()];

          case 2:
            return [2, e.sent()];

          case 3:
            return t = e.sent(), this.handler(t) ? [3, 4] : [2, {
              value: null,
              done: !0
            }];

          case 4:
            return [3, 0];

          case 5:
            return [2];
        }
      });
    });
  }, e;
}(LazyIterator),
    AsyncMapIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    return n.upstream = e, n.transform = r, n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> AsyncMap";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e, r, n, i, o, a;
      return __generator(this, function (u) {
        switch (u.label) {
          case 0:
            return [4, this.upstream.next()];

          case 1:
            return (t = u.sent()).done ? [2, {
              value: null,
              done: !0
            }] : (e = tensor_util.getTensorsInContainer(t.value), [4, this.transform(t.value)]);

          case 2:
            for (r = u.sent(), n = tensor_util.getTensorsInContainer(r), i = 0, o = e; i < o.length; i++) {
              a = o[i], tensor_util.isTensorInList(a, n) || a.dispose();
            }

            return [2, {
              value: r,
              done: !1
            }];
        }
      });
    });
  }, e;
}(LazyIterator),
    OneToManyIterator = function (t) {
  function e() {
    var e = t.call(this) || this;
    return e.outputQueue = new GrowingRingBuffer(), e.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), e;
  }

  return __extends(e, t), e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return 0 !== this.outputQueue.length() ? [3, 2] : [4, this.pump()];

          case 1:
            return t.sent() ? [3, 0] : [2, {
              value: null,
              done: !0
            }];

          case 2:
            return [2, {
              value: this.outputQueue.shift(),
              done: !1
            }];
        }
      });
    });
  }, e;
}(LazyIterator),
    FlatmapIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    return n.upstream = e, n.transform = r, n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Flatmap";
  }, e.prototype.pump = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e, r, n, i, o, a;
      return __generator(this, function (u) {
        switch (u.label) {
          case 0:
            return [4, this.upstream.next()];

          case 1:
            if ((t = u.sent()).done) return [2, !1];

            for (e = tensor_util.getTensorsInContainer(t.value), r = this.transform(t.value), n = tensor_util.getTensorsInContainer(r), this.outputQueue.pushAll(r), i = 0, o = e; i < o.length; i++) {
              a = o[i], tensor_util.isTensorInList(a, n) || a.dispose();
            }

            return [2, !0];
        }
      });
    });
  }, e;
}(OneToManyIterator),
    ChainedIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    return n.baseErrorHandler = r, n.lastRead = null, n.iterator = null, n.moreIterators = e, n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return "TODO: fill in upstream of chained summaries -> Chained";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return this.lastRead = this.readFromChain(this.lastRead), [2, this.lastRead];
      });
    });
  }, e.prototype.readFromChain = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      var e, r;
      return __generator(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, t];

          case 1:
            return n.sent(), null != this.iterator ? [3, 3] : [4, this.moreIterators.next()];

          case 2:
            if ((e = n.sent()).done) return [2, {
              value: null,
              done: !0
            }];
            this.iterator = e.value, null != this.baseErrorHandler && (this.iterator = this.iterator.handleErrors(this.baseErrorHandler)), n.label = 3;

          case 3:
            return [4, this.iterator.next()];

          case 4:
            return (r = n.sent()).done ? (this.iterator = null, [2, this.readFromChain(t)]) : [2, r];
        }
      });
    });
  }, e;
}(LazyIterator);

!function (t) {
  t[t.FAIL = 0] = "FAIL", t[t.SHORTEST = 1] = "SHORTEST", t[t.LONGEST = 2] = "LONGEST";
}(ZipMismatchMode || (ZipMismatchMode = {}));

var ZipIterator = function (t) {
  function e(e, r) {
    void 0 === r && (r = ZipMismatchMode.FAIL);
    var n = t.call(this) || this;
    return n.iterators = e, n.mismatchMode = r, n.count = 0, n.currentPromise = null, n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return "{TODO: fill in upstream of zip summaries} -> Zip";
  }, e.prototype.nextState = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      function e(t) {
        return t instanceof LazyIterator ? {
          value: t.next().then(function (t) {
            return r++, t.done && n++, t.value;
          }),
          recurse: !1
        } : {
          value: null,
          recurse: !0
        };
      }

      var r, n, i;
      return __generator(this, function (o) {
        switch (o.label) {
          case 0:
            return [4, t];

          case 1:
            return o.sent(), r = 0, n = 0, [4, deepMapAndAwaitAll(this.iterators, e)];

          case 2:
            if (i = o.sent(), r === n) return [2, {
              value: null,
              done: !0
            }];
            if (n > 0) switch (this.mismatchMode) {
              case ZipMismatchMode.FAIL:
                throw new Error("Zipped streams should have the same length. Mismatched at element " + this.count + ".");

              case ZipMismatchMode.SHORTEST:
                return [2, {
                  value: null,
                  done: !0
                }];

              case ZipMismatchMode.LONGEST:
            }
            return this.count++, [2, {
              value: i,
              done: !1
            }];
        }
      });
    });
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return this.currentPromise = this.nextState(this.currentPromise), [4, this.currentPromise];

          case 1:
            return [2, t.sent()];
        }
      });
    });
  }, e;
}(LazyIterator),
    PrefetchIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    return n.upstream = e, n.bufferSize = r, n.buffer = new RingBuffer(r), n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Prefetch";
  }, e.prototype.refill = function () {
    for (; !this.buffer.isFull();) {
      var t = this.upstream.next();
      this.buffer.push(t);
    }
  }, e.prototype.next = function () {
    return this.refill(), this.buffer.shift();
  }, e;
}(LazyIterator),
    ShuffleIterator = function (t) {
  function e(e, r, n) {
    var i = t.call(this, e, r) || this;
    return i.upstream = e, i.windowSize = r, i.upstreamExhausted = !1, i.random = seedrandom_1(n || util.now().toString()), i.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), i;
  }

  return __extends(e, t), e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.randomInt = function (t) {
    return Math.floor(this.random() * t);
  }, e.prototype.chooseIndex = function () {
    return this.randomInt(this.buffer.length());
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e;
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            this.upstreamExhausted || this.refill(), r.label = 1;

          case 1:
            return this.buffer.isEmpty() ? [3, 3] : (t = this.chooseIndex(), [4, this.buffer.shuffleExcise(t)]);

          case 2:
            return (e = r.sent()).done ? (this.upstreamExhausted = !0, [3, 1]) : (this.refill(), [2, e]);

          case 3:
            return [2, {
              value: null,
              done: !0
            }];
        }
      });
    });
  }, e;
}(PrefetchIterator),
    Dataset = function () {
  function t() {
    this.size = null;
  }

  return t.prototype.batch = function (t, e) {
    var r = this;
    void 0 === e && (e = !0);
    var n = this;
    return util.assert(t > 0, function () {
      return "batchSize needs to be positive, but it is\n      " + t;
    }), datasetFromIteratorFn(function () {
      return __awaiter(r, void 0, void 0, function () {
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, n.iterator()];

            case 1:
              return [2, r.sent().columnMajorBatch(t, e, deepBatchConcat)];
          }
        });
      });
    }, this.size === 1 / 0 || null == this.size ? this.size : e ? Math.ceil(this.size / t) : Math.floor(this.size / t));
  }, t.prototype.concatenate = function (t) {
    var e = this,
        r = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        var e, n;
        return __generator(this, function (i) {
          switch (i.label) {
            case 0:
              return [4, r.iterator()];

            case 1:
              return n = (e = i.sent()).concatenate, [4, t.iterator()];

            case 2:
              return [2, n.apply(e, [i.sent()])];
          }
        });
      });
    }, this.size === 1 / 0 || t.size === 1 / 0 ? 1 / 0 : null != this.size && null != t.size ? this.size + t.size : null);
  }, t.prototype.filter = function (t) {
    var e = this,
        r = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, r.iterator()];

            case 1:
              return [2, e.sent().filter(function (e) {
                return tidy(function () {
                  return t(e);
                });
              })];
          }
        });
      });
    }, this.size === 1 / 0 ? 1 / 0 : null);
  }, t.prototype.forEachAsync = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, this.iterator()];

          case 1:
            return [2, e.sent().forEachAsync(t)];
        }
      });
    });
  }, t.prototype.forEach = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return deprecationWarn("dataset.forEach() is deprecated and will be removed. Please use dataset.forEachAsync() instead"), [2, this.forEachAsync(t)];
      });
    });
  }, t.prototype.map = function (t) {
    var e = this,
        r = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, r.iterator()];

            case 1:
              return [2, e.sent().map(function (e) {
                return tidy(function () {
                  return t(e);
                });
              })];
          }
        });
      });
    }, this.size);
  }, t.prototype.mapAsync = function (t) {
    var e = this,
        r = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, r.iterator()];

            case 1:
              return [2, e.sent().mapAsync(t)];
          }
        });
      });
    }, this.size);
  }, t.prototype.prefetch = function (t) {
    var e = this;
    if (null == t) throw new RangeError("`Dataset.prefetch()` requires bufferSize to be specified.");
    var r = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, r.iterator()];

            case 1:
              return [2, e.sent().prefetch(t)];
          }
        });
      });
    }, this.size);
  }, t.prototype.repeat = function (t) {
    var e = this,
        r = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        var e = this;
        return __generator(this, function (n) {
          return [2, iteratorFromConcatenated(iteratorFromFunction(function () {
            return __awaiter(e, void 0, void 0, function () {
              var t;
              return __generator(this, function (e) {
                switch (e.label) {
                  case 0:
                    return t = {}, [4, r.iterator()];

                  case 1:
                    return [2, (t.value = e.sent(), t.done = !1, t)];
                }
              });
            });
          }).take(t))];
        });
      });
    }, null != this.size && t > 0 ? this.size * t : 0 === t ? 0 : null != this.size && (void 0 === t || t < 0) ? 1 / 0 : null);
  }, t.prototype.skip = function (t) {
    var e = this,
        r = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, r.iterator()];

            case 1:
              return [2, e.sent().skip(t)];
          }
        });
      });
    }, null != this.size && t >= 0 && this.size >= t ? this.size - t : null != this.size && (this.size < t || void 0 === t || t < 0) ? 0 : null);
  }, t.prototype.shuffle = function (t, e, r) {
    var n = this;
    if (void 0 === r && (r = !0), null == t || t < 0) throw null == this.size ? new RangeError("`Dataset.shuffle()` requires bufferSize to be specified.") : new RangeError("`Dataset.shuffle()` requires bufferSize to be specified.  If your data fits in main memory (for regular JS objects), and/or GPU memory (for `tf.Tensor`s), consider setting bufferSize to the dataset size (" + this.size + " elements)");
    var i = this,
        o = seedrandom_1(e || util.now().toString());
    return datasetFromIteratorFn(function () {
      return __awaiter(n, void 0, void 0, function () {
        var e;
        return __generator(this, function (n) {
          switch (n.label) {
            case 0:
              return e = o.int32(), r && (e += o.int32()), [4, i.iterator()];

            case 1:
              return [2, n.sent().shuffle(t, e.toString())];
          }
        });
      });
    }, this.size);
  }, t.prototype.take = function (t) {
    var e = this,
        r = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, r.iterator()];

            case 1:
              return [2, e.sent().take(t)];
          }
        });
      });
    }, null != this.size && this.size > t ? t : null != this.size && this.size <= t ? this.size : null);
  }, t.prototype.toArray = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            if (this.size === 1 / 0) throw new Error("Can not convert infinite data stream to array.");
            return [4, this.iterator()];

          case 1:
            return [2, t.sent().toArray()];
        }
      });
    });
  }, t.prototype.toArrayForTest = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            if (this.size === 1 / 0) throw new Error("Can not convert infinite data stream to array.");
            return [4, this.iterator()];

          case 1:
            return [2, t.sent().toArrayForTest()];
        }
      });
    });
  }, t.MAX_BUFFER_SIZE = 1e4, t;
}();

function datasetFromIteratorFn(t, e) {
  return void 0 === e && (e = null), new (function (r) {
    function n() {
      var t = null !== r && r.apply(this, arguments) || this;
      return t.size = e, t;
    }

    return __extends(n, r), n.prototype.iterator = function () {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (e) {
          return [2, t()];
        });
      });
    }, n;
  }(Dataset))();
}

function array(t) {
  var e = this;
  return datasetFromIteratorFn(function () {
    return __awaiter(e, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2, iteratorFromItems(t)];
      });
    });
  }, t.length);
}

function zip(t) {
  var e,
      r = this;
  if (!isIterable(t)) throw new Error("The argument to zip() must be an object or array.");
  if (Array.isArray(t)) for (var n = 0; n < t.length; n++) {
    e = null == e ? t[n].size : Math.min(e, t[n].size);
  } else if (t instanceof Object) for (var i in t) {
    e = null == e ? t[i].size : Math.min(e, t[i].size);
  }
  return datasetFromIteratorFn(function () {
    return __awaiter(r, void 0, void 0, function () {
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, deepMapAndAwaitAll(t, function (t) {
              if (t instanceof Dataset) return {
                value: t.iterator(),
                recurse: !1
              };
              if (isIterable(t)) return {
                value: null,
                recurse: !0
              };
              throw new Error("Leaves of the structure passed to zip() must be Datasets, not primitives.");
            })];

          case 1:
            return [2, iteratorFromZipped(e.sent(), ZipMismatchMode.SHORTEST)];
        }
      });
    });
  }, e);
}

function deepBatchConcat(t) {
  return null === t ? null : canTensorify(t[0]) ? {
    value: batchConcat(t),
    recurse: !1
  } : {
    value: null,
    recurse: !0
  };
}

function batchConcat(t) {
  if (0 === t.length) throw new Error("Can't make a batch of zero elements.");
  return t[0] instanceof Tensor ? stack(t) : tensor(t);
}

var TextLineDataset = function (t) {
  function e(e) {
    var r = t.call(this) || this;
    return r.input = e, r;
  }

  return __extends(e, t), e.prototype.iterator = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e;
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            return [4, this.input.iterator()];

          case 1:
            return t = r.sent(), e = t.decodeUTF8(), [2, e.split("\n")];
        }
      });
    });
  }, e;
}(Dataset),
    CODE_QUOTE = '"',
    STATE_OUT = Symbol("out"),
    STATE_FIELD = Symbol("field"),
    STATE_QUOTE = Symbol("quote"),
    STATE_QUOTE_AFTER_QUOTE = Symbol("quoteafterquote"),
    STATE_WITHIN_QUOTE_IN_QUOTE = Symbol("quoteinquote"),
    CSVDataset = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    return n.input = e, n.hasHeader = !0, n.fullColumnNames = null, n.columnNamesValidated = !1, n.columnConfigs = null, n.configuredColumnsOnly = !1, n.delimiter = ",", n.delimWhitespace = !1, n.base = new TextLineDataset(e), r || (r = {}), n.hasHeader = !1 !== r.hasHeader, n.fullColumnNames = r.columnNames, n.columnConfigs = r.columnConfigs, n.configuredColumnsOnly = r.configuredColumnsOnly, r.delimWhitespace ? (util.assert(null == r.delimiter, function () {
      return "Delimiter should not be provided when delimWhitespace is true.";
    }), n.delimWhitespace = !0, n.delimiter = " ") : n.delimiter = r.delimiter ? r.delimiter : ",", n;
  }

  return __extends(e, t), e.prototype.columnNames = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return this.columnNamesValidated ? [3, 2] : [4, this.setColumnNames()];

          case 1:
            t.sent(), t.label = 2;

          case 2:
            return [2, this.configuredColumnsOnly ? Object.keys(this.columnConfigs) : this.fullColumnNames];
        }
      });
    });
  }, e.prototype.setColumnNames = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t,
          e,
          r,
          n,
          i,
          o,
          a = this;
      return __generator(this, function (u) {
        switch (u.label) {
          case 0:
            return [4, this.maybeReadHeaderLine()];

          case 1:
            if (t = u.sent(), !this.fullColumnNames && !t) throw new Error("Column names must be provided if there is no header line.");
            if (this.fullColumnNames && t && util.assert(t.length === this.fullColumnNames.length, function () {
              return "The length of provided columnNames (" + a.fullColumnNames.length.toString() + ") does not match the length of the header line read from file (" + t.length.toString() + ").";
            }), this.fullColumnNames || (this.fullColumnNames = t), e = this.fullColumnNames.reduce(function (t, e) {
              return t[e] = t[e] + 1 || 1, t;
            }, {}), r = Object.keys(e).filter(function (t) {
              return e[t] > 1;
            }), util.assert(0 === r.length, function () {
              return "Duplicate column names found: " + r.toString();
            }), this.columnConfigs) for (n = 0, i = Object.keys(this.columnConfigs); n < i.length; n++) {
              if (o = i[n], -1 === this.fullColumnNames.indexOf(o)) throw new Error('The key "' + o + '" provided in columnConfigs does not match any of the column names (' + this.fullColumnNames.toString() + ").");
            }
            return this.columnNamesValidated = !0, [2];
        }
      });
    });
  }, e.prototype.maybeReadHeaderLine = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e;
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            return this.hasHeader ? [4, this.base.iterator()] : [3, 3];

          case 1:
            return [4, r.sent().next()];

          case 2:
            if ((t = r.sent()).done) throw new Error("No data was found for CSV parsing.");
            return e = t.value, [2, this.parseRow(e, !1)];

          case 3:
            return [2, null];
        }
      });
    });
  }, e.prototype.iterator = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t,
          e = this;
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            return this.columnNamesValidated ? [3, 2] : [4, this.setColumnNames()];

          case 1:
            r.sent(), r.label = 2;

          case 2:
            return [4, this.base.iterator()];

          case 3:
            return t = r.sent(), this.hasHeader && (t = t.skip(1)), [2, t.map(function (t) {
              return e.makeDataElement(t);
            })];
        }
      });
    });
  }, e.prototype.makeDataElement = function (t) {
    for (var e = this.parseRow(t), r = {}, n = {}, i = 0; i < this.fullColumnNames.length; i++) {
      var o = this.fullColumnNames[i],
          a = this.columnConfigs ? this.columnConfigs[o] : null;

      if (!this.configuredColumnsOnly || a) {
        var u = e[i],
            s = null;
        if ("" === u) {
          if (a && void 0 !== a.default) s = a.default;else {
            if (a && (a.required || a.isLabel)) throw new Error("Required column " + o + " is empty in this line: " + t);
            s = void 0;
          }
        } else {
          var c = Number(u);
          if (isNaN(c)) s = a && "bool" === a.dtype ? this.getBoolean(u) : u;else if (a && a.dtype) switch (a.dtype) {
            case "float32":
              s = c;
              break;

            case "int32":
              s = Math.floor(c);
              break;

            case "bool":
              s = this.getBoolean(u);
              break;

            default:
              s = c;
          } else s = c;
        }
        a && a.isLabel ? n[o] = s : r[o] = s;
      }
    }

    return 0 === Object.keys(n).length ? r : {
      xs: r,
      ys: n
    };
  }, e.prototype.getBoolean = function (t) {
    return "1" === t || "true" === t.toLowerCase() ? 1 : 0;
  }, e.prototype.parseRow = function (t, e) {
    void 0 === e && (e = !0);

    for (var r = [], n = 0, i = t.length, o = STATE_OUT, a = 0; a < i; a++) {
      switch (o) {
        case STATE_OUT:
          switch (t.charAt(a)) {
            case CODE_QUOTE:
              n = a + 1, o = STATE_QUOTE;
              break;

            case this.delimiter:
              if (n = a + 1, " " === this.delimiter && this.delimWhitespace) break;
              r.push(""), o = STATE_OUT;
              break;

            default:
              o = STATE_FIELD, n = a;
          }

          break;

        case STATE_FIELD:
          switch (t.charAt(a)) {
            case this.delimiter:
              r.push(t.substring(n, a)), o = STATE_OUT, n = a + 1;
          }

          break;

        case STATE_QUOTE:
          switch (t.charAt(a)) {
            case CODE_QUOTE:
              o = STATE_QUOTE_AFTER_QUOTE;
          }

          break;

        case STATE_QUOTE_AFTER_QUOTE:
          switch (t.charAt(a)) {
            case this.delimiter:
              r.push(t.substring(n, a - 1)), o = STATE_OUT, n = a + 1;
              break;

            case CODE_QUOTE:
              o = STATE_QUOTE;
              break;

            default:
              o = STATE_WITHIN_QUOTE_IN_QUOTE;
          }

          break;

        case STATE_WITHIN_QUOTE_IN_QUOTE:
          switch (t.charAt(a)) {
            case CODE_QUOTE:
              o = STATE_QUOTE;
          }

      }
    }

    if (o === STATE_QUOTE_AFTER_QUOTE ? r.push(t.substring(n, i - 1)) : r.push(t.substring(n)), e && r.length !== this.fullColumnNames.length) throw new Error("Invalid row in csv file. Should have " + this.fullColumnNames.length + " elements in a row, but got " + r);
    return r;
  }, e;
}(Dataset),
    environment = createCommonjsModule(function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var r = function () {
    function t(t) {
      this.global = t, this.flags = {}, this.flagRegistry = {}, this.urlFlags = {}, this.populateURLFlags();
    }

    return t.prototype.registerFlag = function (t, e, r) {
      if (this.flagRegistry[t] = {
        evaluationFn: e,
        setHook: r
      }, null != this.urlFlags[t]) {
        var n = this.urlFlags[t];
        console.warn("Setting feature override from URL " + t + ": " + n + "."), this.set(t, n);
      }
    }, t.prototype.get = function (t) {
      return t in this.flags ? this.flags[t] : (this.flags[t] = this.evaluateFlag(t), this.flags[t]);
    }, t.prototype.getNumber = function (t) {
      return this.get(t);
    }, t.prototype.getBool = function (t) {
      return this.get(t);
    }, t.prototype.getFlags = function () {
      return this.flags;
    }, Object.defineProperty(t.prototype, "features", {
      get: function get() {
        return this.flags;
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype.set = function (t, e) {
      if (null == this.flagRegistry[t]) throw new Error("Cannot set flag " + t + " as it has not been registered.");
      this.flags[t] = e, null != this.flagRegistry[t].setHook && this.flagRegistry[t].setHook(e);
    }, t.prototype.evaluateFlag = function (t) {
      if (null == this.flagRegistry[t]) throw new Error("Cannot evaluate flag '" + t + "': no evaluation function found.");
      return this.flagRegistry[t].evaluationFn();
    }, t.prototype.setFlags = function (t) {
      this.flags = Object.assign({}, t);
    }, t.prototype.reset = function () {
      this.flags = {}, this.urlFlags = {}, this.populateURLFlags();
    }, t.prototype.populateURLFlags = function () {
      var t = this;

      if (void 0 !== this.global && void 0 !== this.global.location && void 0 !== this.global.location.search) {
        var e = n(this.global.location.search);
        if ("tfjsflags" in e) e.tfjsflags.split(",").forEach(function (e) {
          var r = e.split(":"),
              n = r[0],
              i = r[1];

          t.urlFlags[n] = function (t, e) {
            if ("true" === (e = e.toLowerCase()) || "false" === e) return "true" === e;
            if ("" + +e === e) return +e;
            throw new Error("Could not parse value flag value " + e + " for flag " + t + ".");
          }(n, i);
        });
      }
    }, t;
  }();

  function n(t) {
    var e = {};
    return t.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, function (t) {
      for (var r = [], n = 1; n < arguments.length; n++) {
        r[n - 1] = arguments[n];
      }

      return function (t, e, r) {
        t[decodeURIComponent(e)] = decodeURIComponent(r || "");
      }(e, r[0], r[1]), r.join("=");
    }), e;
  }

  e.Environment = r, e.getQueryParams = n, e.setEnvironmentGlobal = function (t) {
    e.ENV = t;
  };
});

unwrapExports(environment);
var environment_1 = environment.Environment,
    environment_2 = environment.getQueryParams,
    environment_3 = environment.ENV,
    environment_4 = environment.setEnvironmentGlobal,
    util$1 = createCommonjsModule(function (t, e) {
  function r(t) {
    for (var e = t.length, r = 0, n = 0; e > 0;) {
      n = Math.random() * e | 0, r = t[--e], t[e] = t[n], t[n] = r;
    }
  }

  function n(t, e) {
    if (!t) throw new Error("string" == typeof e ? e : e());
  }

  function i(t, e) {
    if (void 0 === e && (e = []), null == e && (e = []), Array.isArray(t) || c(t)) for (var r = 0; r < t.length; ++r) {
      i(t[r], e);
    } else e.push(t);
    return e;
  }

  function o(t, e) {
    if (t === e) return !0;
    if (null == t || null == e) return !1;
    if (t.length !== e.length) return !1;

    for (var r = 0; r < t.length; r++) {
      if (t[r] !== e[r]) return !1;
    }

    return !0;
  }

  function a(t) {
    return t % 1 == 0;
  }

  function u(t, e) {
    var r = e.length;
    return n((t = null == t ? e.map(function (t, e) {
      return e;
    }) : [].concat(t)).every(function (t) {
      return t >= -r && t < r;
    }), function () {
      return "All values in axis param must be in range [-" + r + ", " + r + ") but got axis " + t;
    }), n(t.every(function (t) {
      return a(t);
    }), function () {
      return "All values in axis param must be integers but got axis " + t;
    }), t.map(function (t) {
      return t < 0 ? r + t : t;
    });
  }

  function s(t, e) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      if (isNaN(n) || !isFinite(n)) throw Error("A tensor of type " + e + " being uploaded contains " + n + ".");
    }
  }

  function c(t) {
    return t instanceof Float32Array || t instanceof Int32Array || t instanceof Uint8Array;
  }

  function l(t) {
    return "string" == typeof t || t instanceof String;
  }

  function f(t) {
    return "boolean" == typeof t;
  }

  function h(t) {
    return "number" == typeof t;
  }

  function p(t, e) {
    if (null == e || "float32" === e || "complex64" === e) return new Float32Array(t);
    if ("int32" === e) return new Int32Array(t);
    if ("bool" === e) return new Uint8Array(t);
    throw new Error("Unknown data type " + e);
  }

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.shuffle = r, e.clamp = function (t, e, r) {
    return Math.max(t, Math.min(e, r));
  }, e.nearestLargerEven = function (t) {
    return t % 2 == 0 ? t : t + 1;
  }, e.sum = function (t) {
    for (var e = 0, r = 0; r < t.length; r++) {
      e += t[r];
    }

    return e;
  }, e.randUniform = function (t, e) {
    var r = Math.random();
    return e * r + (1 - r) * t;
  }, e.distSquared = function (t, e) {
    for (var r = 0, n = 0; n < t.length; n++) {
      var i = Number(t[n]) - Number(e[n]);
      r += i * i;
    }

    return r;
  }, e.assert = n, e.assertShapesMatch = function (t, e, r) {
    void 0 === r && (r = ""), n(o(t, e), function () {
      return r + " Shapes " + t + " and " + e + " must match";
    });
  }, e.assertNonNull = function (t) {
    n(null != t, function () {
      return "The input to the tensor constructor must be a non-null value.";
    });
  }, e.flatten = i, e.sizeFromShape = function (t) {
    if (0 === t.length) return 1;

    for (var e = t[0], r = 1; r < t.length; r++) {
      e *= t[r];
    }

    return e;
  }, e.isScalarShape = function (t) {
    return 0 === t.length;
  }, e.arraysEqual = o, e.isInt = a, e.tanh = function (t) {
    if (null != Math.tanh) return Math.tanh(t);
    if (t === 1 / 0) return 1;
    if (t === -1 / 0) return -1;
    var e = Math.exp(2 * t);
    return (e - 1) / (e + 1);
  }, e.sizeToSquarishShape = function (t) {
    var e = Math.ceil(Math.sqrt(t));
    return [e, Math.ceil(t / e)];
  }, e.createShuffledIndices = function (t) {
    for (var e = new Uint32Array(t), n = 0; n < t; ++n) {
      e[n] = n;
    }

    return r(e), e;
  }, e.rightPad = function (t, e) {
    return e <= t.length ? t : t + " ".repeat(e - t.length);
  }, e.repeatedTry = function (t, e, r) {
    return void 0 === e && (e = function e(t) {
      return 0;
    }), new Promise(function (n, i) {
      var o = 0,
          a = function a() {
        if (t()) n();else {
          var u = e(++o);
          null != r && o >= r ? i() : setTimeout(a, u);
        }
      };

      a();
    });
  }, e.inferFromImplicitShape = function (t, e) {
    for (var r = 1, n = -1, i = 0; i < t.length; ++i) {
      if (t[i] >= 0) r *= t[i];else if (-1 === t[i]) {
        if (-1 !== n) throw Error("Shapes can only have 1 implicit size. Found -1 at dim " + n + " and dim " + i);
        n = i;
      } else if (t[i] < 0) throw Error("Shapes can not be < 0. Found " + t[i] + " at dim " + i);
    }

    if (-1 === n) {
      if (e > 0 && e !== r) throw Error("Size(" + e + ") must match the product of shape " + t);
      return t;
    }

    if (0 === r) throw Error("Cannot infer the missing size in [" + t + "] when there are 0 elements");
    if (e % r != 0) throw Error("The implicit shape can't be a fractional number. Got " + e + " / " + r);
    var o = t.slice();
    return o[n] = e / r, o;
  }, e.parseAxisParam = u, e.squeezeShape = function (t, e) {
    for (var r = [], n = [], i = null == e ? null : u(e, t).sort(), o = 0, a = 0; a < t.length; ++a) {
      if (null != i) {
        if (i[o] === a && 1 !== t[a]) throw new Error("Can't squeeze axis " + a + " since its dim '" + t[a] + "' is not 1");
        (null == i[o] || i[o] > a) && 1 === t[a] && (r.push(t[a]), n.push(a)), i[o] <= a && o++;
      }

      1 !== t[a] && (r.push(t[a]), n.push(a));
    }

    return {
      newShape: r,
      keptDims: n
    };
  }, e.getTypedArrayFromDType = function (t, e) {
    var r = null;
    if (null == t || "float32" === t) r = new Float32Array(e);else if ("int32" === t) r = new Int32Array(e);else {
      if ("bool" !== t) throw new Error("Unknown data type " + t);
      r = new Uint8Array(e);
    }
    return r;
  }, e.getArrayFromDType = function (t, e) {
    var r = null;
    if (null == t || "float32" === t) r = new Float32Array(e);else if ("int32" === t) r = new Int32Array(e);else if ("bool" === t) r = new Uint8Array(e);else {
      if ("string" !== t) throw new Error("Unknown data type " + t);
      r = new Array(e);
    }
    return r;
  }, e.checkComputationForErrors = function (t, e, r) {
    if ("float32" === e) for (var n = 0; n < t.length; n++) {
      var i = t[n];
      if (isNaN(i) || !isFinite(i)) throw Error("The result of the '" + r + "' is " + i + ".");
    }
  }, e.checkConversionForErrors = s, e.hasEncodingLoss = function (t, e) {
    return !("complex64" === e || "float32" === e && "complex64" !== t || "int32" === e && "float32" !== t && "complex64" !== t || "bool" === e && "bool" === t);
  }, e.isTypedArray = c, e.bytesPerElement = function (t) {
    if ("float32" === t || "int32" === t) return 4;
    if ("complex64" === t) return 8;
    if ("bool" === t) return 1;
    throw new Error("Unknown dtype " + t);
  }, e.bytesFromStringArray = function (t) {
    if (null == t) return 0;
    var e = 0;
    return t.forEach(function (t) {
      return e += 2 * t.length;
    }), e;
  }, e.isString = l, e.isBoolean = f, e.isNumber = h, e.inferDtype = function t(e) {
    return Array.isArray(e) ? t(e[0]) : e instanceof Float32Array ? "float32" : e instanceof Int32Array || e instanceof Uint8Array ? "int32" : h(e) ? "float32" : l(e) ? "string" : f(e) ? "bool" : "float32";
  }, e.isFunction = function (t) {
    return !!(t && t.constructor && t.call && t.apply);
  }, e.nearestDivisor = function (t, e) {
    for (var r = e; r < t; ++r) {
      if (t % r == 0) return r;
    }

    return t;
  }, e.computeStrides = function (t) {
    var e = t.length;
    if (e < 2) return [];
    var r = new Array(e - 1);
    r[e - 2] = t[e - 1];

    for (var n = e - 3; n >= 0; --n) {
      r[n] = r[n + 1] * t[n + 1];
    }

    return r;
  }, e.toTypedArray = function (t, e, r) {
    if ("string" === e) throw new Error("Cannot convert a string[] to a TypedArray");
    if (Array.isArray(t) && (t = i(t)), r && s(t, e), function (t, e) {
      return t instanceof Float32Array && "float32" === e || t instanceof Int32Array && "int32" === e || t instanceof Uint8Array && "bool" === e;
    }(t, e)) return t;
    if (null == e || "float32" === e || "complex64" === e) return new Float32Array(t);
    if ("int32" === e) return new Int32Array(t);

    if ("bool" === e) {
      for (var n = new Uint8Array(t.length), o = 0; o < n.length; ++o) {
        0 !== Math.round(t[o]) && (n[o] = 1);
      }

      return n;
    }

    throw new Error("Unknown data type " + e);
  }, e.toNestedArray = function (t, e) {
    if (0 === t.length) return e[0];
    var r = t.reduce(function (t, e) {
      return t * e;
    });
    if (0 === r) return [];
    if (r !== e.length) throw new Error("[" + t + "] does not match the input size.");
    return function t(e, r, n) {
      var i = new Array();
      if (1 === r.length) for (var o = r[0], a = 0; a < o; a++) {
        i[a] = n[e + a];
      } else {
        o = r[0];
        var u = r.slice(1),
            s = u.reduce(function (t, e) {
          return t * e;
        });

        for (a = 0; a < o; a++) {
          i[a] = t(e + a * s, u, n);
        }
      }
      return i;
    }(0, t, e);
  }, e.makeOnesTypedArray = function (t, e) {
    for (var r = p(t, e), n = 0; n < r.length; n++) {
      r[n] = 1;
    }

    return r;
  }, e.makeZerosTypedArray = p, e.now = function () {
    if ("undefined" != typeof performance) return performance.now();

    if ("undefined" != typeof process) {
      var t = process.hrtime();
      return 1e3 * t[0] + t[1] / 1e6;
    }

    throw new Error("Cannot measure time in this environment. You should run tf.js in the browser or in Node.js");
  }, e.assertNonNegativeIntegerDimensions = function (t) {
    t.forEach(function (e) {
      n(Number.isInteger(e) && e >= 0, function () {
        return "Tensor must have a shape comprised of positive integers but got shape [" + t + "].";
      });
    });
  };

  var d = function d() {
    if (null != environment.ENV.global.fetch) return environment.ENV.global.fetch;
    if (environment.ENV.get("IS_NODE")) return e.getNodeFetch.fetchImport();
    throw new Error("Unable to find the fetch() method. Please add your own fetch() function to the global namespace.");
  };

  e.getNodeFetch = {
    fetchImport: function fetchImport() {
      return require("node-fetch");
    }
  }, e.fetch = function (t, r) {
    return null == e.systemFetch && (e.systemFetch = d()), e.systemFetch(t, r);
  };
});
unwrapExports(util$1);

var util_1 = util$1.shuffle,
    util_2 = util$1.clamp,
    util_3 = util$1.nearestLargerEven,
    util_4 = util$1.sum,
    util_5 = util$1.randUniform,
    util_6 = util$1.distSquared,
    util_7 = util$1.assert,
    util_8 = util$1.assertShapesMatch,
    util_9 = util$1.assertNonNull,
    util_10 = util$1.flatten,
    util_11 = util$1.sizeFromShape,
    util_12 = util$1.isScalarShape,
    util_13 = util$1.arraysEqual,
    util_14 = util$1.isInt,
    util_15 = util$1.tanh,
    util_16 = util$1.sizeToSquarishShape,
    util_17 = util$1.createShuffledIndices,
    util_18 = util$1.rightPad,
    util_19 = util$1.repeatedTry,
    util_20 = util$1.inferFromImplicitShape,
    util_21 = util$1.parseAxisParam,
    util_22 = util$1.squeezeShape,
    util_23 = util$1.getTypedArrayFromDType,
    util_24 = util$1.getArrayFromDType,
    util_25 = util$1.checkComputationForErrors,
    util_26 = util$1.checkConversionForErrors,
    util_27 = util$1.hasEncodingLoss,
    util_28 = util$1.isTypedArray,
    util_29 = util$1.bytesPerElement,
    util_30 = util$1.bytesFromStringArray,
    util_31 = util$1.isString,
    util_32 = util$1.isBoolean,
    util_33 = util$1.isNumber,
    util_34 = util$1.inferDtype,
    util_35 = util$1.isFunction,
    util_36 = util$1.nearestDivisor,
    util_37 = util$1.computeStrides,
    util_38 = util$1.toTypedArray,
    util_39 = util$1.toNestedArray,
    util_40 = util$1.makeOnesTypedArray,
    util_41 = util$1.makeZerosTypedArray,
    util_42 = util$1.now,
    util_43 = util$1.assertNonNegativeIntegerDimensions,
    util_44 = util$1.getNodeFetch,
    util_45 = util$1.systemFetch,
    util_46 = util$1.fetch,
    WebcamIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    if (n.webcamVideoElement = e, n.webcamConfig = r, n.isClosed = !0, n.resize = !1, n.needToResize()) if (n.resize = !0, n.cropSize = [n.webcamConfig.resizeHeight, n.webcamConfig.resizeWidth], n.cropBoxInd = tensor1d([0], "int32"), n.webcamConfig.centerCrop) {
      var i = 1 * n.webcamConfig.resizeWidth / n.webcamVideoElement.width,
          o = 1 * n.webcamConfig.resizeHeight / n.webcamVideoElement.height,
          a = (1 - i) / 2,
          u = (1 - o) / 2,
          s = a + i,
          c = o + u;
      n.cropBox = tensor2d([u, a, c, s], [1, 4]);
    } else n.cropBox = tensor2d([0, 0, 1, 1], [1, 4]);
    return n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return "webcam";
  }, e.create = function (t, r) {
    return void 0 === r && (r = {}), __awaiter(this, void 0, void 0, function () {
      var n;
      return __generator(this, function (i) {
        switch (i.label) {
          case 0:
            if (ENV.get("IS_NODE")) throw new Error("tf.data.webcam is only supported in browser environment.");

            if (!t) {
              if (t = document.createElement("video"), !r.resizeWidth || !r.resizeHeight) throw new Error("Please provide webcam video element, or resizeWidth and resizeHeight to create a hidden video element.");
              t.width = r.resizeWidth, t.height = r.resizeHeight;
            }

            return [4, (n = new e(t, r)).start()];

          case 1:
            return i.sent(), [2, n];
        }
      });
    });
  }, e.prototype.start = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t,
          e,
          r = this;
      return __generator(this, function (n) {
        switch (n.label) {
          case 0:
            this.webcamConfig.facingMode && util_7("user" === this.webcamConfig.facingMode || "environment" === this.webcamConfig.facingMode, function () {
              return "Invalid webcam facing mode: " + r.webcamConfig.facingMode + ". Please provide 'user' or 'environment'";
            }), n.label = 1;

          case 1:
            return n.trys.push([1, 3,, 4]), t = this, [4, navigator.mediaDevices.getUserMedia({
              video: {
                deviceId: this.webcamConfig.deviceId,
                facingMode: this.webcamConfig.facingMode ? this.webcamConfig.facingMode : "user",
                width: this.webcamVideoElement.width,
                height: this.webcamVideoElement.height
              }
            })];

          case 2:
            return t.stream = n.sent(), [3, 4];

          case 3:
            throw (e = n.sent()).message = "Error thrown while initializing video stream: " + e.message, e;

          case 4:
            if (!this.stream) throw new Error("Could not obtain video from webcam.");

            try {
              this.webcamVideoElement.srcObject = this.stream;
            } catch (t) {
              console.log(t), this.webcamVideoElement.src = window.URL.createObjectURL(this.stream);
            }

            return this.webcamVideoElement.play(), this.isClosed = !1, [2, new Promise(function (t) {
              r.webcamVideoElement.onloadedmetadata = function () {
                t();
              };
            })];
        }
      });
    });
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (e) {
        if (this.isClosed) return [2, {
          value: null,
          done: !0
        }];

        try {
          t = browser.fromPixels(this.webcamVideoElement);
        } catch (t) {
          throw new Error("Error thrown converting video to pixels: " + JSON.stringify(t));
        }

        if (!this.resize) return [2, {
          value: t,
          done: !1
        }];

        try {
          return [2, {
            value: this.cropAndResizeFrame(t),
            done: !1
          }];
        } catch (t) {
          throw new Error("Error thrown cropping the video: " + t.message);
        }

        return [2];
      });
    });
  }, e.prototype.needToResize = function () {
    return !(!this.webcamConfig.resizeWidth || !this.webcamConfig.resizeHeight || this.webcamVideoElement.width === this.webcamConfig.resizeWidth && this.webcamVideoElement.height === this.webcamConfig.resizeHeight);
  }, e.prototype.cropAndResizeFrame = function (t) {
    var e,
        r = t.toFloat().expandDims(0),
        n = (e = image.cropAndResize(r, this.cropBox, this.cropBoxInd, this.cropSize, "bilinear")).shape;
    return e.reshape(n.slice(1));
  }, e.prototype.capture = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return [4, this.next()];

          case 1:
            return [2, t.sent().value];
        }
      });
    });
  }, e.prototype.stop = function () {
    this.stream.getTracks().forEach(function (t) {
      return t.stop();
    });

    try {
      this.webcamVideoElement.srcObject = null;
    } catch (t) {
      console.log(t), this.webcamVideoElement.src = null;
    }

    this.isClosed = !0;
  }, e.prototype.toArray = function () {
    throw new Error("Can not convert infinite video stream to array.");
  }, e;
}(LazyIterator),
    DataSource = function () {
  return function () {};
}(),
    StringIterator = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return __extends(e, t), e.prototype.split = function (t) {
    return new SplitIterator(this, t);
  }, e;
}(LazyIterator),
    SplitIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    return n.upstream = e, n.impl = new SplitIteratorImpl(e, r), n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.impl.summary();
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, this.impl.next()];
      });
    });
  }, e;
}(StringIterator),
    SplitIteratorImpl = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;
    return n.upstream = e, n.separator = r, n.carryover = "", n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Split('" + this.separator + "')";
  }, e.prototype.pump = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e, r, n, i;
      return __generator(this, function (o) {
        switch (o.label) {
          case 0:
            return [4, this.upstream.next()];

          case 1:
            if ((t = o.sent()).done) return "" === this.carryover ? [2, !1] : (this.outputQueue.push(this.carryover), this.carryover = "", [2, !0]);

            for ((e = t.value.split(this.separator))[0] = this.carryover + e[0], r = 0, n = e.slice(0, -1); r < n.length; r++) {
              i = n[r], this.outputQueue.push(i);
            }

            return this.carryover = e[e.length - 1], [2, !0];
        }
      });
    });
  }, e;
}(OneToManyIterator),
    ByteChunkIterator = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return __extends(e, t), e.prototype.decodeUTF8 = function () {
    return new Utf8Iterator(this);
  }, e;
}(LazyIterator),
    Utf8Iterator = function (t) {
  function e(e) {
    var r = t.call(this) || this;
    return r.upstream = e, r.impl = new Utf8IteratorImpl(e), r;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.impl.summary();
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, this.impl.next()];
      });
    });
  }, e;
}(StringIterator),
    Utf8IteratorImpl = function (t) {
  function e(e) {
    var r = t.call(this) || this;
    if (r.upstream = e, ENV.get("IS_BROWSER")) r.decoder = new TextDecoder("utf-8");else {
      var n = require("string_decoder").StringDecoder;

      r.decoder = new n("utf8");
    }
    return r;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Utf8";
  }, e.prototype.pump = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e, r;
      return __generator(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, this.upstream.next()];

          case 1:
            return (t = n.sent()).done ? [2, !1] : (e = t.value, r = ENV.get("IS_BROWSER") ? this.decoder.decode(e, {
              stream: !0
            }) : this.decoder.write(Buffer.from(e.buffer)), this.outputQueue.push(r), [2, !0]);
        }
      });
    });
  }, e;
}(OneToManyIterator),
    FileChunkIterator = function (t) {
  function e(e, r) {
    void 0 === r && (r = {});
    var n = t.call(this) || this;
    return n.file = e, n.options = r, util.assert(e instanceof Uint8Array || !!ENV.get("IS_BROWSER") && (e instanceof File || e instanceof Blob), function () {
      return "FileChunkIterator only supports File, Blob and Uint8Array right now.";
    }), n.offset = r.offset || 0, n.chunkSize = r.chunkSize || 1048576, n;
  }

  return __extends(e, t), e.prototype.summary = function () {
    return "FileChunks " + this.file;
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t,
          e,
          r = this;
      return __generator(this, function (n) {
        switch (n.label) {
          case 0:
            return this.offset >= (this.file instanceof Uint8Array ? this.file.byteLength : this.file.size) ? [2, {
              value: null,
              done: !0
            }] : (t = new Promise(function (t, e) {
              var n = r.offset + r.chunkSize;
              if (r.file instanceof Uint8Array) t(new Uint8Array(r.file.slice(r.offset, n)));else {
                var i = new FileReader();
                i.onload = function (r) {
                  var n = i.result;
                  if (n instanceof ArrayBuffer && (n = new Uint8Array(n)), !(n instanceof Uint8Array)) return e(new TypeError("FileReader returned unknown type."));
                  t(n);
                }, i.onabort = function (t) {
                  return e(new Error("Aborted"));
                }, i.onerror = function (t) {
                  return e(new Error(t.type));
                };
                var o = r.file.slice(r.offset, n);
                i.readAsArrayBuffer(o);
              }
              r.offset = n;
            }), e = {}, [4, t]);

          case 1:
            return [2, (e.value = n.sent(), e.done = !1, e)];
        }
      });
    });
  }, e;
}(ByteChunkIterator);

function urlChunkIterator(t, e) {
  return void 0 === e && (e = {}), __awaiter(this, void 0, void 0, function () {
    var r, n, i, o;
    return __generator(this, function (a) {
      switch (a.label) {
        case 0:
          return ENV.get("IS_BROWSER") ? [4, fetch(t)] : [3, 5];

        case 1:
          return (r = a.sent()).ok ? [4, r.blob()] : [3, 3];

        case 2:
          return n = a.sent(), [2, new FileChunkIterator(n, e)];

        case 3:
          throw new Error(r.statusText);

        case 4:
          return [3, 9];

        case 5:
          if (i = require("node-fetch"), "string" != typeof t) throw new Error("URL must be a string. Request objects are not supported in the node.js environment yet.");
          return [4, i(t)];

        case 6:
          return (r = a.sent()).ok ? [4, r.buffer()] : [3, 8];

        case 7:
          return o = a.sent(), [2, new FileChunkIterator(o, e)];

        case 8:
          throw new Error(r.statusText);

        case 9:
          return [2];
      }
    });
  });
}

function isLocalPath(t) {
  return "string" == typeof t && "file://" === t.substr(0, 7);
}

var FileDataSource = function (t) {
  function e(e, r) {
    void 0 === r && (r = {});
    var n = t.call(this) || this;
    return n.input = e, n.options = r, n;
  }

  return __extends(e, t), e.prototype.iterator = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (e) {
        return isLocalPath(this.input) && ENV.get("IS_NODE") && (t = require("fs"), this.input = t.readFileSync(this.input.substr(7))), [2, new FileChunkIterator(this.input, this.options)];
      });
    });
  }, e;
}(DataSource),
    URLDataSource = function (t) {
  function e(e, r) {
    void 0 === r && (r = {});
    var n = t.call(this) || this;
    return n.url = e, n.fileOptions = r, n;
  }

  return __extends(e, t), e.prototype.iterator = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return isLocalPath(this.url) ? [2, new FileDataSource(this.url, this.fileOptions).iterator()] : [2, urlChunkIterator(this.url, this.fileOptions)];
      });
    });
  }, e;
}(DataSource);

function csv(t, e) {
  return void 0 === e && (e = {}), new CSVDataset(new URLDataSource(t), e);
}

function func(t) {
  var e = this,
      r = iteratorFromFunction(t);
  return datasetFromIteratorFn(function () {
    return __awaiter(e, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, r];
      });
    });
  });
}

function generator(t) {
  var e = this;
  return datasetFromIteratorFn(function () {
    return __awaiter(e, void 0, void 0, function () {
      var e;
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            return [4, t()];

          case 1:
            return e = r.sent(), [2, iteratorFromFunction(function () {
              return e.next();
            })];
        }
      });
    });
  });
}

function webcam(t, e) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (r) {
      return [2, WebcamIterator.create(t, e)];
    });
  });
}

var version = "1.1.2";
export { array, Dataset, zip, CSVDataset, TextLineDataset, csv, func, generator, webcam, FileDataSource, URLDataSource, version as version_data };